module.exports = __webpack_public_path__ + "images/c18ef08f97d8bce0827b09fcdbac170d.png";